module.exports = __webpack_public_path__ + "28a06b8a5c333cdf2e9b40594d1c04f9.svg";